module.exports = __webpack_public_path__ + "img/chatgroup.10a92587.png";